module.exports = __webpack_public_path__ + "img/responsive crc-06.39cf53e7.jpg";